/**
 * Mandatory fragrance: open popup on ATC click; user selects fragrance and confirms in modal; add parent + child via cart/add.js.
 * @version v1.7
 */
var EE_MANDATORY_FRAGRANCE_VERSION = 'v1.7';
(function () {
  var logPrefix = '[ee-mandatory-fragrance v1.7]';
  console.log(logPrefix, 'script loaded');

  function init() {
    console.log(logPrefix, 'init() called');
    const modal = document.getElementById('ee-mandatory-fragrance-modal');
    const container = document.querySelector('[data-ee-mandatory-fragrance]');
    if (!modal || !container) {
      console.log(logPrefix, 'ABORT: modal or container not found');
      return;
    }
    console.log(logPrefix, 'modal and container found');

    const configEl = document.querySelector('[data-ee-mandatory-fragrance-config]');
    if (!configEl) {
      console.log(logPrefix, 'ABORT: config element [data-ee-mandatory-fragrance-config] not found');
      return;
    }
    console.log(logPrefix, 'config element found, raw length:', configEl.textContent ? configEl.textContent.length : 0);

    let config;
    try {
      config = JSON.parse(configEl.textContent.trim());
      console.log(logPrefix, 'config parsed OK', config);
    } catch (e) {
      console.error(logPrefix, 'ABORT: config JSON parse error', e);
      console.log(logPrefix, 'raw config text:', configEl.textContent ? configEl.textContent.substring(0, 200) : 'empty');
      return;
    }

    // Resolve the form that the main product Add to Cart uses: buy-buttons[form="product-form-main-..."] points to it.
    var form = null;
    var formId = '';
    var buyButtonsEl = document.querySelector('.product .buy-buttons[form^="product-form-main-"]');
    if (buyButtonsEl) {
      formId = buyButtonsEl.getAttribute('form') || '';
      var elWithId = formId ? document.getElementById(formId) : null;
      if (elWithId) {
        if (elWithId.tagName && elWithId.tagName.toUpperCase() === 'FORM') {
          form = elWithId;
        } else if (elWithId.closest) {
          form = elWithId.closest('form');
        }
      }
    }
    if (!form) {
      form = document.querySelector('.product form[action*="cart/add"]');
    }
    if (!form) {
      console.log(logPrefix, 'ABORT: form not found');
      return;
    }
    formId = form.id || formId;
    console.log(logPrefix, 'form found', form.tagName, form.id || '(no id)');

    const submitButtons = Array.from(form.elements || []).filter(function (el) {
      return el.type === 'submit';
    });

    function getSelectedFragranceVariantId() {
      const checked = container.querySelector('input[name="ee-mandatory-fragrance-variant"]:checked');
      return checked ? parseInt(checked.value, 10) : null;
    }

    function getParentVariantId() {
      const idInput = form.querySelector('input[name="id"]');
      return idInput ? parseInt(idInput.value, 10) : config.parentVariantId;
    }

    function getQuantity() {
      const qtyInput = form.querySelector('input[name="quantity"]');
      return qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    }

    function doAddToCart(fragranceId, done) {
      const parentVariantId = getParentVariantId();
      const quantity = getQuantity();
      const items = [
        { id: parentVariantId, quantity: quantity, properties: { _requires_fragrance: '1' } },
        { id: fragranceId, quantity: quantity, properties: { _mandatory_for_variant_id: String(parentVariantId), Complimentary: 'Yes' } }
      ];
      console.log(logPrefix, 'doAddToCart: parentVariantId=', parentVariantId, 'fragranceId=', fragranceId);

      submitButtons.forEach((btn) => btn.setAttribute('aria-busy', 'true'));
      if (document.documentElement) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      }
      var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js';
      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items })
      })
        .then(function (r) { return r.json(); })
        .then(function (responseJson) {
          submitButtons.forEach((btn) => btn.removeAttribute('aria-busy'));
          if (document.documentElement) {
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          }
          if (responseJson.id || (responseJson.items && responseJson.items.length)) {
            var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cartContent) {
              var sectionId = null;
              var cartDrawerEl = document.querySelector('cart-drawer');
              if (cartDrawerEl && cartDrawerEl.closest) {
                var sectionEl = cartDrawerEl.closest('.shopify-section');
                if (sectionEl && sectionEl.id) sectionId = sectionEl.id.replace('shopify-section-', '');
              }
              if (sectionId) {
                return fetch(root + '?section_id=' + encodeURIComponent(sectionId)).then(function (r) { return r.text(); }).then(function (sectionHtml) {
                  cartContent.sections = cartContent.sections || {};
                  cartContent.sections[sectionId] = sectionHtml;
                  return { cart: cartContent, itemsAdded: responseJson.items || [responseJson] };
                });
              }
              return { cart: cartContent, itemsAdded: responseJson.items || [responseJson] };
            });
          }
          return Promise.reject(new Error(responseJson.message || 'Add to cart failed'));
        })
        .then(function (result) {
          if (modal.hide && typeof modal.hide === 'function') modal.hide();
          form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: result.itemsAdded, cart: result.cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: result.cart } }));
          var message = (window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.addedToCart || '{{product_title}} was added to cart').replace('{{product_title}}', result.itemsAdded[0] && result.itemsAdded[0].title ? result.itemsAdded[0].title : '');
          document.dispatchEvent(new CustomEvent('toast:show', { detail: { message } }));
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          if (window.themeVariables && window.themeVariables.settings && (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart')) {
            window.location.href = root + 'cart';
          }
          if (done) done();
        })
        .catch(function (err) {
          submitButtons.forEach((btn) => btn.removeAttribute('aria-busy'));
          if (document.documentElement) {
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
          }
          var msg = (err && err.message) ? err.message : 'Network error';
          form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: msg } }));
          document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: msg, tone: 'error' } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (done) done();
        });
    }

    form.addEventListener('submit', function (e) {
      console.log(logPrefix, 'SUBMIT fired, opening modal');
      e.preventDefault();
      e.stopImmediatePropagation();
      if (config.allFragrancesOos) {
        if (config.strings && config.strings.all_oos) {
          document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: config.strings.all_oos, tone: 'error' } }));
        }
        return;
      }
      if (modal.show && typeof modal.show === 'function') modal.show();
    }, true);

    var modalAtc = container.querySelector('[data-ee-modal-add]');
    if (modalAtc) {
      modalAtc.addEventListener('click', function () {
        var fragranceId = getSelectedFragranceVariantId();
        if (!fragranceId) {
          if (config.strings && config.strings.please_select) {
            document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: config.strings.please_select, tone: 'error' } }));
          }
          return;
        }
        doAddToCart(fragranceId);
      });
    }

    form.addEventListener('variant:change', function () {
      config.parentVariantId = getParentVariantId();
    });
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.addEventListener('change', function () {
        config.parentVariantId = getParentVariantId();
      });
    }

    console.log(logPrefix, 'listeners attached (form submit -> open modal; modal ATC -> add and close)');
  }

  if (document.readyState === 'loading') {
    console.log(logPrefix, 'waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
